import { FC } from 'react';

import GenericLayout from '../../components/generic-layout/GenericLayout';
import { H1 } from '../../components/heading/Hx';
import List from '../../components/list/List';
import ListItem from '../../components/list/ListItem';
import NoPageImageSection from '../../components/section/NoPageImageSection';
import { useConfigContext } from '../../context/ConfigContext';
import { COLOR } from '../../theme/type';

const Agb: FC = () => {
  const { company } = useConfigContext();

  return (
    <GenericLayout title='AGB'>
      <NoPageImageSection>
        <H1 center color={COLOR.Gold1} position='static'>
          Allgemeine Geschäftsbedingungen (AGB)
        </H1>
        <List numbers>
          <ListItem>
            Der Vertragspartner ist mit Abschluss des Vertrags berechtigt, an den von der{' '}
            {company.name} angebotenen Trainingseinheiten und Seminaren teilzunehmen. Das Training
            findet während der Öffnungszeiten und nach Maßgabe des jeweils aktuellen Trainings- und
            Seminarplans in den Räumen der {company.name} statt.
          </ListItem>
          <ListItem>
            Der Vertragspartner bestätigt in einer ausreichend guten körperlichen und psychischen
            Verfassung zu sein, um am Trainingsbetrieb teilnehmen zu können. Der Vertragspartner ist
            sich bewusst, dass er an einem Kampfsporttraining teilnimmt und dass Verletzungen nicht
            100%ig ausgeschlossen werden können. Etwaig vorhandene Verletzungen oder Einschränkungen
            hat er dem Trainer rechtzeitig vor Beginn des Trainings mitzuteilen. Treten sie während
            des Trainings auf, sind sie dem Trainer unverzüglich mitzuteilen. Der Trainer
            entscheidet sodann, ob der Vertragspartner am Training teilnehmen bzw. es fortsetzen
            darf.
          </ListItem>
          <ListItem>
            Intensives und konzentriertes Training ist stets ein Schlüssel zum Erfolg. Aber
            Verbissenheit, Egoismus und unkameradschaftliches Verhalten sind als Zerstörer einer
            guten, gelösten und fröhlichen Trainingsatmosphäre unerwünscht.
          </ListItem>
          <ListItem>
            Das Gebot sportlicher Fairness ist deshalb immer – insbesondere auch gegenüber den
            anderen Teilnehmern – zu beachten. Die {company.name} behält sich vor, Störenfriede von
            einzelnen Trainingseinheiten und Seminaren auszuschließen. Schuldhafte Schädigungen
            durch den Vertragspartner führen in der Regel zur fristlosen Kündigung. Anordnungen und
            Hinweisen des Trainingspersonals ist im übrigen Folge zu leisten.
          </ListItem>
          <ListItem>
            Die Trainingsräume dürfen nur mit geeigneter Sportbekleidung und Sportschuhen, die nur
            im Innenraum benutzt werden, betreten werden. Mit Einrichtungsgegenständen ist pfleglich
            umzugehen.
          </ListItem>
          <ListItem>
            Das Training findet nur statt, wenn ein Trainer der {company.name} anwesend ist. Ein von
            Seiten der {company.name} zu verantwortender Trainingsausfall begründet keinen
            Beitrags-Erstattungsanspruch für den Vertragspartner.
          </ListItem>
          <ListItem>
            Gebühren für Training und Seminare sind im Voraus zu bezahlen. Eine Beitrags-Erstattung
            ist ausgeschlossen.
          </ListItem>
          <ListItem>
            Der Vertragspartner bedarf zur Herstellung von Foto- und Video-Aufnahmen jeder Art in
            den Trainingsräumen der {company.name} der vorherigen Zustimmung der {company.name}.
          </ListItem>
        </List>
      </NoPageImageSection>
    </GenericLayout>
  );
};

export default Agb;
